// extracted by mini-css-extract-plugin
export default {"root":"root--mJ89h","el":"el--SYWld"};